export default __webpack_public_path__ + "static/media/tomatoes.eba00eae.png";